module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-oyster-abstract-balmoral-0.78c76209.jpg";